/**
 * app常量
 */
export var App;
(function (App) {
    App[App["Auto"] = 1] = "Auto";
    App[App["None"] = 2] = "None";
    App[App["Voghion"] = 4] = "Voghion";
    App[App["MocasaShopping"] = 8] = "MocasaShopping"; // mocasa shopping
})(App = App || (App = {}));
/**
 * voghion 应用配置
 */
export const voghionConfig = {
    app: App.Voghion,
    name: 'Voghion',
    ua: ['voghion']
};
/**
 * mocasa shopping 应用配置
 */
export const mocasaShoppingConfig = {
    app: App.MocasaShopping,
    name: 'MocasaShopping',
    ua: ['mocasashopping']
};
